import api from './api';

const categoriaService = {
  listar: async (tipo = null) => {
    const params = tipo ? { tipo } : {};
    const { data } = await api.get('/categorias', { params });
    return data.data;
  },
};

export default categoriaService;